var _rect, _rect2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCircle2Check(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.22286,
    y: 1.22261,
    width: 41.5548,
    height: 41.5548,
    rx: 20.7774,
    fill: "#2AA663"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1.22286,
    y: 1.22261,
    width: 41.5548,
    height: 41.5548,
    rx: 20.7774,
    stroke: "#2AA663",
    strokeWidth: 0.848056
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.6696 27.8232V26.3705L22.5238 22.5922C22.8924 22.2199 23.1996 21.8893 23.4453 21.6001C23.6911 21.311 23.8754 21.031 23.9982 20.7599C24.1211 20.4889 24.1826 20.1998 24.1826 19.8926C24.1826 19.542 24.1031 19.2421 23.944 18.9927C23.785 18.7398 23.5664 18.5446 23.2881 18.4073C23.0099 18.27 22.6936 18.2013 22.3395 18.2013C21.9745 18.2013 21.6546 18.2772 21.38 18.429C21.1053 18.5771 20.8921 18.7885 20.7403 19.0632C20.5922 19.3379 20.5181 19.6649 20.5181 20.0444H18.6045C18.6045 19.3397 18.7654 18.7271 19.087 18.2067C19.4086 17.6863 19.8513 17.2834 20.4151 16.9979C20.9825 16.7124 21.633 16.5696 22.3666 16.5696C23.111 16.5696 23.7652 16.7088 24.3289 16.987C24.8927 17.2653 25.33 17.6466 25.6408 18.1308C25.9552 18.6151 26.1124 19.168 26.1124 19.7896C26.1124 20.2052 26.0329 20.6136 25.8739 21.0147C25.7148 21.4158 25.4348 21.8603 25.0336 22.3482C24.6361 22.8361 24.0778 23.427 23.3586 24.1208L21.445 26.0669V26.1428H26.2804V27.8232H18.6696Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircle2Check);
export default __webpack_public_path__ + "static/media/Circle2Check.bc75df6963c404eda61e78ebe44586cf.svg";
export { ForwardRef as ReactComponent };